<template>
  <div class="flag" style="height: 100%;">
    <app-base-main parentTable>
      <template #filter-group>
        <app-filter-group @reset="$gjReset" @query="$gjNoticeQuery">
            <gj-country-server-select
              v-model="filter.countryMarketValue"
              :width="['140px', '170px']"
            ></gj-country-server-select>
            <gj-date-picker
              v-model="filter.date"
             :clearable="false"
            ></gj-date-picker>
        </app-filter-group>
      </template>
      <template #operate-group>
          <gj-button type="primary" style="height: 32px;" @click="synchronization()">同步</gj-button>
      </template>
      <template #tool-group>
        <gj-tool-group
            download download-url="/operation/performance/export" :download-params="globalParams"
            help >
        </gj-tool-group>
      </template>
      <template #table>
        <PromptMessage :updateTime="updateTime"/>
        <div style="flex: 1; overflow: auto">
        <gj-table
          ref="gjTable"
          adaptParent
          size='has-picture'
          :index="false"
          name="store-performance"
          :data="tableData"
          :columns="columns"
          :loading="loading"
          :default-sort="{prop: 'orderWithDefectRate', order: 'descending'}"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery">
          <template v-slot:orderWithDefectRate="{ row }">
              <div class="normal" @click="pushDetails('#customer-service', row.marketId, row.countryCode)" :class="row.orderWithDefectRateTarget === false ? 'abnormal' : ''"> {{ row.orderWithDefectRate || 0}} </div>
              <div> {{ row.orderWithDefectTimeStart | convertToDate }} - {{ row.orderWithDefectTimeEnd | convertToDate }} </div>
          </template>
          <template v-slot:returnDissatisfactionRate="{ row }">
              <div class="normal" @click="pushDetails('#customer-service', row.marketId, row.countryCode)" :class="row.returnDissatisfactionRateTarget === false ? 'abnormal' : ''"> {{ row.returnDissatisfactionRate || 0}} </div>
              <div> {{ row.returnDissatisfactionTimeStart | convertToDate}} - {{ row.returnDissatisfactionTimeEnd | convertToDate }} </div>
          </template>
          <template v-slot:validTrackingRate="{ row }">
              <div class="normal" @click="pushDetails('#distribution-performance', row.marketId, row.countryCode)" :class="row.validTrackingRateTarget === false ? 'abnormal' : ''"> {{ row.validTrackingRate || 0}} </div>
              <div> {{ row.validTrackingTimeStart | convertToDate }} - {{ row.validTrackingTimeEnd | convertToDate }} </div>
          </template>
          <template v-slot:preFulfillmentCancellationRate="{ row }">
              <div class="normal" @click="pushDetails('#distribution-performance', row.marketId, row.countryCode)" :class="row.preFulfillmentCancellationRateTarget === false ? 'abnormal' : ''"> {{ row.preFulfillmentCancellationRate || 0}} </div>
              <div> {{ row.preFulfillmentCancellationTimeStart | convertToDate }} - {{ row.preFulfillmentCancellationTimeEnd | convertToDate }} </div>
          </template>
          <template v-slot:lateShipmentRate="{ row }">
              <div class="normal" @click="pushDetails('#distribution-performance', row.marketId, row.countryCode)" :class="row.lateShipmentRateTarget === false ? 'abnormal' : ''"> {{ row.lateShipmentRate || 0}} </div>
              <div> {{ row.lateShipmentTimeStart | convertToDate }} - {{ row.lateShipmentTimeEnd | convertToDate }} </div>
          </template>
          <template v-slot:commodityPolicyDefect="{ row }">
              <div class="normal" @click="pushDetails('#product-compliance', row.marketId, row.countryCode)" :class="row.commodityPolicyDefectTarget === false ? 'abnormal' : ''"> {{ row.commodityPolicyDefect || 0}} </div>
          </template>
        </gj-table>
        </div>
      </template>
    </app-base-main>
  </div>
</template>

<script>
import {isMeaningfulMixin, queryMixin, selectionMixin} from "@/minxins";
import { performance, executeSyncJob } from "@/api/statistics"
import { convertToDate } from "@/utils/date.util.js"
import PromptMessage from "./components/prompt-message.vue";
export default {
  name: "statistics-store-performance",
  mixins: [queryMixin, selectionMixin, isMeaningfulMixin],
  components: { PromptMessage },
  data() {
    return {
      loading: false, // 加载
      tableData: [], // 表格数据
      updateTime: "", // 更新时间
      filter: {
        countryMarketValue: {},
        date: new Date()
      },
      columns: [
          {id: 'marketName', header: '店铺名称', field: 'marketName', minWidth: '120px', default: true},
          {id: 'orderWithDefectRate', header: '订单缺陷率(<1%)', field: 'slot:orderWithDefectRate', minWidth: '120px', default: true, disabled: true, sortable: true},
          {id: 'returnDissatisfactionRate', header: '退货不满意率(<10%)', field: 'slot:returnDissatisfactionRate', minWidth: '120px', default: true, disabled: true, sortable: true},
          {id: 'validTrackingRate', header: '有效追踪率(>95%)', field: 'slot:validTrackingRate', minWidth: '120px', default: true, sortable: true},
          {id: 'preFulfillmentCancellationRate', header: '订单取消率(<2.50%)', field: 'slot:preFulfillmentCancellationRate', minWidth: '120px', sortable: true},
          {id: 'lateShipmentRate', header: '延迟发货率(<4.00%)', field: 'slot:lateShipmentRate', minWidth: '120px', sortable: true},
          {id: 'commodityPolicyDefect', header: '商品政策合规性', field: 'slot:commodityPolicyDefect', minWidth: '120px', sortable: true},
      ],
      notStorage: true
    }
  },
  filters: {
    convertToDate(val) {
      if (!val) { return "" }
      return convertToDate(new Date(val))
    }
  },
  methods: {
    RateInit(val) {
      if (!val) { return 0 }
      return Number(val.split("%")[0])
    },
    // 重置
    $gjQueryInitParams() {
        this.filter.countryMarketValue = {}
        this.filter.date = new Date()
    },
    // 查询
    $gjQuery() {
        this.performance()
    },
    // 获取数据
    async performance() {
      this.loading = true
      let params = {
        dataTime: convertToDate(this.filter.date),
        countryCodes: this.filter.countryMarketValue.countryIds || [],
        marketIds: this.filter.countryMarketValue.marketIds || [],
        ...this.querySort
      }
      this.globalParams = params;
      try {
        let { updateTime, dataList } = await performance(params) || {}
        this.tableData = dataList
        this.updateTime = updateTime
      } finally {
        this.loading = false
      }
    },
    // 跳转详情
    pushDetails(anchorRoll, marketId, countryCode) {
      sessionStorage.setItem("anchorRoll", anchorRoll);
      this.$router.push({
        path: "/statistics/store-performance-details",
        query: {
          marketId,
          countryCode
        }
      })
    },
    // 同步
    async synchronization() {
      this.loading = true
      try {
        await executeSyncJob()
        this.performance()
      } finally {
        this.loading = false
      }
    }
  },
  created() {
    this.sort.prop = "orderWithDefectRate"
  }
}
</script>

<style scoped lang="scss">
.normal {
  color: #2DA641;
  cursor: pointer;
}
.abnormal {
  color: #F5222D;
}
/deep/ .parent-table{
  display: flex;
  flex-direction: column;
}
</style>
